import { useLanguage } from '../context/LanguageContext';
import { getPayoff } from '../lib/payoff';

const SeoSchema = () => {
  const { language } = useLanguage();
  const payoff = getPayoff(language);

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Italian Roots Discovery",
    "alternateName": "IRD",
    "slogan": payoff.short,
    "url": "https://italianrootsdiscovery.com",
    "logo": "https://customer-assets.emergentagent.com/job_return-dialog/artifacts/of4eva1w_IMG-20260114-WA0048.jpg",
    "description": language === 'it'
      ? "Italian Roots Discovery: il riferimento unico per i Comuni italiani sui bandi e finanziamenti. Ricerca genealogica professionale, turismo delle radici e consulenza europea."
      : language === 'es'
      ? "Italian Roots Discovery: el referente único para los Municipios italianos en convocatorias y financiación. Investigación genealógica profesional, turismo de las raíces y consultoría europea."
      : language === 'pt'
      ? "Italian Roots Discovery: o referente único para os Municípios italianos em editais e financiamentos. Pesquisa genealógica profissional, turismo das raízes e consultoria europeia."
      : "Italian Roots Discovery: the single reference point for Italian Comuni on grants and funding. Professional genealogical research, roots tourism and European consulting.",
    "foundingDate": "1995",
    "founder": [
      { "@type": "Person", "name": "Laura Stella", "jobTitle": "Writer & Genealogical Research Specialist" },
      { "@type": "Person", "name": "Giosia Caliò", "jobTitle": "Genealogical Research Specialist & Translator" }
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IT"
    },
    "contactPoint": [
      { "@type": "ContactPoint", "telephone": "+39-331-879-2031", "contactType": "customer service", "availableLanguage": ["Italian", "English", "Spanish", "Portuguese"] },
      { "@type": "ContactPoint", "telephone": "+39-392-073-4627", "contactType": "customer service", "availableLanguage": ["Italian", "English", "Spanish", "Portuguese"] }
    ],
    "sameAs": ["https://www.facebook.com/italianrootsdiscovery", "https://www.instagram.com/italianrootsdiscovery"],
    "areaServed": { "@type": "Place", "name": "Worldwide" },
    "priceRange": "$$",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Genealogical Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": { "@type": "Service", "name": "Ricerca Genealogica Estesa", "description": "Complete genealogical research across Italian archives" }
        },
        {
          "@type": "Offer",
          "itemOffered": { "@type": "Service", "name": "Recupero Documenti", "description": "Official document retrieval from Italian municipalities" }
        },
        {
          "@type": "Offer",
          "itemOffered": { "@type": "Service", "name": "Assistenza Cittadinanza", "description": "Support for Italian citizenship by descent applications" }
        }
      ]
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Come posso scoprire le mie radici italiane?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Offriamo una valutazione gratuita iniziale dove analizziamo le informazioni che hai sulla tua famiglia per determinare il percorso migliore di ricerca genealogica."
        }
      },
      {
        "@type": "Question",
        "name": "Quanto tempo richiede una ricerca genealogica?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "I tempi variano da 2 a 6 mesi a seconda della complessità del caso e della disponibilità dei documenti negli archivi comunali e parrocchiali."
        }
      },
      {
        "@type": "Question",
        "name": "Posso ottenere la cittadinanza italiana tramite i miei antenati?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sì, se puoi dimostrare una linea di discendenza ininterrotta da un antenato italiano, potresti avere diritto alla cittadinanza italiana per discendenza (jure sanguinis)."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Italian Roots Discovery",
    "@id": "https://italianrootsdiscovery.com",
    "telephone": "+39-331-879-2031",
    "email": "italianrootsdiscovery@gmail.com",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "18:00"
    }
  };

  // Escape closing script tags to prevent any HTML injection in JSON-LD blocks.
  // Note: dangerouslySetInnerHTML is the standard React pattern for embedding
  // <script type="application/ld+json"> — content here is internal/static and escaped.
  const safeJson = (obj) => JSON.stringify(obj).replace(/</g, '\\u003c');

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJson(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJson(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJson(localBusinessSchema) }} />
    </>
  );
};

export default SeoSchema;
